/* eslint-disable @typescript-eslint/naming-convention */
import { Table as TiptapTable } from '@tiptap/extension-table';
import { VueNodeViewRenderer } from '@tiptap/vue-3';
import LegacyTeachinoTable from './LegacyTeachinoTable.vue';

export const Table = TiptapTable.extend({
  draggable: true,
  selectable: true,
  atom: true,
  group: 'block',

  addNodeView() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    return VueNodeViewRenderer(LegacyTeachinoTable);
  },
});
